

















































import { Component, Vue } from 'vue-property-decorator';
import { BffSettings } from '@/api/bff';

interface CardSetting {
  key: string;
  translationKey: string;
  fullKey: string;
}

interface CardConfig {
  name: string;
  index: number;
  icon: string;
  settings: CardSetting[];
}

@Component({})
export default class CardSettingsTab extends Vue {
  loading = false;

  error: string | null = null;

  changes = false;

  expandedPanels: number[] = [];

  cardSettings: Record<string, boolean> = {};

  get cardsWithSettings(): CardConfig[] {
    const allCards: CardConfig[] = [
      {
        name: 'planning',
        index: 5,
        icon: 'mdi-clock-time-four-outline',
        settings: [
          {
            key: 'scenarioChangeConfirmation',
            translationKey: 'settings.planning.scenarioChangeConfirmation',
            fullKey: 'planning.scenarioChangeConfirmation'
          }
        ]
      },
      {
        name: 'devices',
        index: 1,
        icon: 'mdi-devices',
        settings: []
      },
      {
        name: 'reports',
        index: 2,
        icon: 'mdi-file-document-multiple-outline',
        settings: []
      },
      {
        name: 'telemetry',
        index: 3,
        icon: 'mdi-monitor-arrow-down-variant',
        settings: []
      },
      {
        name: 'creator',
        index: 4,
        icon: 'mdi-chart-box-plus-outline',
        settings: []
      },
      {
        name: 'optimization',
        index: 6,
        icon: 'mdi-finance',
        settings: []
      },
      {
        name: 'analytics',
        index: 7,
        icon: 'mdi-poll',
        settings: []
      },
      {
        name: 'submissions',
        index: 9,
        icon: 'mdi-clipboard-text-multiple',
        settings: []
      },
      {
        name: 'settings',
        index: 10,
        icon: 'mdi-cog-outline',
        settings: []
      }
    ];

    return allCards.filter((card) => card.settings.length > 0);
  }

  isSettingEnabled(cardName: string, settingKey: string): boolean {
    const fullKey = `${cardName}.${settingKey}`;
    return this.cardSettings[fullKey] ?? false;
  }

  refreshPage() {
    window.location.reload();
  }

  async fetchData() {
    try {
      this.loading = true;
      this.error = null;

      this.cardSettings = await BffSettings.getCardSettings();
    } catch (err) {
      this.error = err instanceof Error ? err.message : 'Failed to load card settings';
    } finally {
      this.loading = false;
    }
  }

  async toggleSetting(cardName: string, settingKey: string) {
    const fullKey = `${cardName}.${settingKey}`;
    const isEnabled = this.isSettingEnabled(cardName, settingKey);

    this.cardSettings[fullKey] = !isEnabled;

    try {
      await BffSettings.updateCardSettings(this.cardSettings);
    } catch (err) {
      this.cardSettings[fullKey] = isEnabled;
      console.error('Failed to update card setting:', err);
    } finally {
      this.changes = true;
    }
  }

  async mounted() {
    await this.fetchData();
  }
}
